import React from "react";
import "./ContactAdmin.css";

function ContactAdmin() {
  return (
    <div className="contact-page">
      <div className="contact-card">
        <div className="contact-icon">
          <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 18v-6a9 9 0 0 1 18 0v6" />
            <path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z" />
          </svg>
        </div>

        <h1>Need Help?</h1>

        <p className="subtitle">
          Contact the system administrator for login, password, or account access issues.
        </p>

        <div className="admin-info">
          <p>📧 Email: admin@company.com</p>
          <p>📞 Phone: +94 77 123 4567</p>
          <p>🕘 Office Hours: Mon - Fri / 8.00 AM - 5.00 PM</p>
        </div>

        <a className="back-link" href="/">
          Back to Login
        </a>
      </div>
    </div>
  );
}

export default ContactAdmin;